import React, { useEffect, useContext } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from 'react-helmet';
import { AppContext } from './AppContext'; // adjust path as needed

import Header from './Header';
import Footer from './Footer';

export default function PrivacyPolicy() {
    const { settings } = useContext(AppContext);
    const brandName = settings?.brandName || '';

    useEffect(() => {
        AOS.init({ once: true });
    }, []);

    return (
        <>
            <Helmet>
                <title>Privacy Policy | {brandName}</title>
                <meta
                    name="description"
                    content={`Read the Privacy Policy of ${brandName}`}
                />
            </Helmet>

            <Header />

            <main
                className="p-6 lg:p-16 max-w-4xl mx-auto text-center"
                data-aos="fade-up"
            >
                <h1 className="text-4xl font-bold mb-6">Privacy Policy</h1>
                <p className="text-base text-gray-700 leading-relaxed">
                    Here is the Privacy Policy for {brandName}.
                </p>
            </main>

            <Footer />
        </>
    );
}
